import { Product, ValidityType } from "@ridango/core";

export class ValidityTypes {

    private static types = Object.values(ValidityType);

    static get(product: Product): ValidityType {
        if (!product || !product.product_properties) {
            return ValidityType.activatedOnFirstValidation;
        }

        const pp = product.product_properties.find(pp => this.types.includes(pp.code as ValidityType));

        return pp ? pp.code as ValidityType : ValidityType.activatedOnFirstValidation;
    }
}